import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import TabsBlockProFile from '../../../../components/user/TabsBlockProFile'
import { datasetsPersonalInformation, tabProfile } from '../../../../config/datasetsProfile'

const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

class PersonalInformation extends Component {
	state = {
		detailProfile : [],
		dataNewProfile : {},
		loaddingDataNews : false
	}

	fetchProfile = async () =>{
		const { client, location } = this.props
		try{
			let dataProfileDetail = await client.query({
				query: Queries.fetchProfile,
			})



			let dataEmployeeProfile = await client.query({
				query: Queries.fetchEmployeeProfile,
			})
			// console.log(dataProfileDetail.data)
			this.newDataProfile(dataProfileDetail.data.fetchProfile)
			this.newDataProfile(dataEmployeeProfile.data.fetchEmployeeProfile)
		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// message.error("Token is expired.")
		}
    }

	newDataProfile = async(detailProfileAll) =>{
		const { detailProfile, dataNewProfile } = this.state
		const data = [];
		console.log('detailProfile',detailProfileAll)
		if(detailProfileAll){
			await Object.keys(detailProfileAll).map((keysProfile)=>{
				if(typeof detailProfileAll[keysProfile] == 'object' && detailProfileAll[keysProfile]){
					Object.keys(detailProfileAll[keysProfile]).map((keysFloor1)=>{
						if(typeof detailProfileAll[keysProfile][keysFloor1] == 'object' && detailProfileAll[keysProfile][keysFloor1]){
							Object.keys(detailProfileAll[keysProfile][keysFloor1]).map((keysFloor2)=>{
								if(typeof detailProfileAll[keysProfile][keysFloor1][keysFloor2] == 'object' && detailProfileAll[keysProfile][keysFloor1][keysFloor2]){
									Object.keys(detailProfileAll[keysProfile][keysFloor1]).map((keysFloor3)=>{
										data[keysProfile+'.'+keysFloor1+keysFloor2+keysFloor3] = detailProfileAll[keysProfile][keysFloor1][keysFloor2][keysFloor3]
									})
								}else{
									data[keysProfile+'.'+keysFloor1+keysFloor2] = detailProfileAll[keysProfile][keysFloor1][keysFloor2]
								}
							})
						}else{
							data[keysProfile+'.'+keysFloor1] = detailProfileAll[keysProfile][keysFloor1]
						}
					})
				}else{
					data[keysProfile] = detailProfileAll[keysProfile]
				}
			})
	
			const dataMap = await this.mapDataTax(data)
	
			await this.setState({
				dataNewProfile : dataMap,
			})
		}
       
	}

	mapDataTax = async (newDataProfile) =>{
		const { location } = this.props
		const { detailProfile } = this.state
		let dataValue = [];
		await datasetsPersonalInformation.filter(valueCategory => valueCategory.catrgoryName == location.pathname.split('/')[2]).map(filterValueCategory =>{
			filterValueCategory.Tab.map((valueTab, keys)=>{
				valueTab.form.map((valueForm)=>{
					valueForm.formValue.map((valueInput)=>{
						if(newDataProfile[valueInput.keyMapdata]){
							valueInput.value = newDataProfile[valueInput.keyMapdata]
							valueInput.keyMapdata = ''
						}
					})
				})
			})
			dataValue = filterValueCategory.Tab
		})

		return dataValue
	}
	
	inputTextArea = (valueInput, disabled) =>{
		return (
			<Input.TextArea 
				value={ valueInput.value ? valueInput.value : 'ไม่พบข้อมูล' } 
				className={ valueInput.value ? '' : 'font-italic' } 
				rows="3"
				disabled={disabled}
			/>
		)
	}
    
    fetchTabPane = () =>{
		const { location } = this.props
		const { loaddingDataNews, dataNewProfile } = this.state
		// console.log('dataNewProfile',dataNewProfile)
		return tabProfile.map((value)=>{
			if(location.pathname.split('/')[2] == value['slugProfile']){
				return value['tabs'].map((valueTab,keys)=>
					<TabPane tab={valueTab.title} key={keys} className="mb-0">
						<Row gutter={16}>
							{
								Object.keys(dataNewProfile).length > 0 &&
								dataNewProfile.filter(valueDataTab => valueDataTab.name == valueTab.name).map(filterTab =>{
									return filterTab.form.map((valueForm)=>
										<>
											{
												<Col xs={24} md={24} className="mb-2">
													<strong className="color-red">
														{ valueForm.title }
													</strong>
												</Col>
											}
											{
												valueForm.formValue.map((valueInput)=>
													<>
														{ 
															valueInput.offset == '12' &&
															<Row gutter={16}>
																<Col xs={24} sm={valueInput.col} className="mb-3">
																	<Text>
																		{ valueInput.label }
																	</Text><br></br>
																	{ 
																		(
																			valueInput.label == 'รายละเอียดเพิ่มเติม' ||
																			valueInput.label == 'สิทธิการจอดรถ' ||
																			valueInput.label == 'หมายเหตุสิทธิการจอดรถ'
																		)
																		&&
																			this.inputTextArea(valueInput,false)
																			// <Input.TextArea 
																			// 	value={ valueInput.value ? valueInput.value : 'ไม่พบข้อมูล' } 
																			// 	className={ valueInput.value ? '' : 'font-italic' } 
																			// 	rows="3"
																			// />
																		||
																		<Input 
																			value={ valueInput.value ? valueInput.value : 'ไม่พบข้อมูล' } 
																			className={ valueInput.value ? '' : 'font-italic' } 
																			disabled={true}
																		/>
																	}
																	
																</Col>
															</Row>
															||
															<Col xs={24} sm={valueInput.col} className="mb-3">
																<Text>
																	{ valueInput.label }
																</Text><br></br>
																{ 
																	(
																		valueInput.label == 'รายละเอียดเพิ่มเติม' ||
																		valueInput.label == 'สิทธิการจอดรถ' ||
																		valueInput.label == 'หมายเหตุสิทธิการจอดรถ'
																	)
																	&&
																		this.inputTextArea(valueInput,true)
																		// <Input.TextArea 
																		// 	value={ valueInput.value ? valueInput.value : 'ไม่พบข้อมูล' } 
																		// 	rows="3"
																		// 	className={ valueInput.value ? '' : 'font-italic' } 
																		// 	disabled={true}
																		// />
																	||
																	<Input 
																		value={ valueInput.value ? valueInput.value : 'ไม่พบข้อมูล' } 
																		className={ valueInput.value ? '' : 'font-italic' } 
																		disabled={true}
																	/>
																}
															</Col>

														}
													</>
												)
											}
											<Col xs={24} md={24} className="mb-2">
												<hr/>
											</Col>
										</>
									)
								})
								||
								<div style={{textAlign:"center"}}>
									<Spin size="large" />
								</div>
							}
							{/* <TabsBlockProFile/> */}
						</Row>
					</TabPane>
				)
			}
		})
	}

	async componentDidMount(){
		const newsDataProfile = '';
		const { history, location, match, staticContext } = this.props
		const { detailProfile } = this.state
		await this.fetchProfile()
		// await this.newDataProfile()
	}
	render() {
		const { history, location, match, staticContext } = this.props
        const { loaddingDataNews, dataNewProfile} = this.state
        
		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
							{ this.fetchTabPane() }
						</Tabs>
					</div>
				</div>
			</Container>
		)
	}
}

PersonalInformation.propTypes = {
	//
}

export default withApollo(PersonalInformation)
